'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MCIcon = exports.FAIcon = exports.Icon = undefined;

var _FAIcon2 = require('./FAIcon');

var _FAIcon3 = _interopRequireDefault(_FAIcon2);

var _MCIcon2 = require('./MCIcon');

var _MCIcon3 = _interopRequireDefault(_MCIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Icon = _FAIcon3.default;
exports.FAIcon = _FAIcon3.default;
exports.MCIcon = _MCIcon3.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvaWNvbi9pbmRleC5qc3giXSwibmFtZXMiOlsiSWNvbiIsIkZBSWNvbiIsIk1DSWNvbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7UUFBT0EsSTtRQUNBQyxNO1FBQ0FDLE0iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgSWNvbiBmcm9tICcuL0ZBSWNvbidcbmV4cG9ydCBGQUljb24gZnJvbSAnLi9GQUljb24nXG5leHBvcnQgTUNJY29uIGZyb20gJy4vTUNJY29uJ1xuIl19